
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1440","height":"56","viewBox":"0 0 1440 56","preserveAspectRatio":"none","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1440 45.158c-95.58 0-106.97 8.285-226.98 8.285-120.01 0-176.22-32.37-296.232-32.37-105.102 0-97.379 12.801-217.388 12.801C606.223 33.874 539.34 0 431.831 0 311.822 0 315.306 19.49 195.333 19.49 75.36 19.49 80.641 8.17 0 8.17V56h1440V45.158z","fill":"currentColor"}})])
          )
        }
      }
    